import { useAtomValue } from 'jotai';
import React, { ReactNode, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { routes } from '../data/routes';
import { authedAtom } from '../lib/Session';
import { useInfoToast } from './hooks/toasters';

type AuthenticatedProps = {
  children: ReactNode;
  noRedirect?: boolean;
};

export const Authenticated = ({ children, noRedirect }: AuthenticatedProps) => {
  const toast = useInfoToast();
  const navigate = useNavigate();
  const authed = useAtomValue(authedAtom);

  useEffect(() => {
    if (!authed && !noRedirect) {
      navigate(routes.logIn);
      toast({ title: 'Please log in or register to continue' });
    }
  }, [authed, noRedirect, navigate, toast]);

  if (authed) {
    return <>{children}</>;
  }

  return null;
};

export const UnAuthenticated = (props: any) => {
  const authed = useAtomValue(authedAtom);

  if (!authed) {
    return <>{props.children}</>;
  } else {
    return null;
  }
};
